import React, { memo } from 'react';
import PropTypes from 'prop-types';
import ReactPaginate from 'react-paginate';
import css from 'styled-jsx/css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronLeft,
  faChevronRight,
  faEllipsis,
} from '@fortawesome/free-solid-svg-icons';

export default memo(PaginationFooter);

const { className: brandedBackgroundClass, styles: brandedBackgroundStyles } =
  css.resolve`
    a.page-link {
      background-color: var(--brand-primary-alert) !important;
      color: var(--white) !important;
    }
  `;

const { className: brandedTextClass, styles: brandedTextStyles } = css.resolve`
  a {
    color: var(--brand-primary) !important;
  }
`;

function PaginationFooter(props) {
  const conditionalForcePage = props.pages ? { forcePage: props.page - 1 } : {};

  return (
    <>
      <ReactPaginate
        {...conditionalForcePage}
        activeClassName="rounded-lg"
        activeLinkClassName={`${brandedBackgroundClass} rounded-lg`}
        breakClassName="page-item disabled"
        breakLabel={<FontAwesomeIcon icon={faEllipsis} />}
        breakLinkClassName={`page-link border-0 text-dark shadow-none ${brandedTextClass}`}
        containerClassName={
          props.rowsLoading || !props.rowsLength
            ? 'd-none'
            : 'pagination pagination-sm justify-content-center mt-2 mb-0 align-items-center'
        }
        disabledClassName="disabled"
        disableInitialCallback
        marginPagesDisplayed={1}
        nextClassName="page-item"
        nextLabel={<FontAwesomeIcon icon={faChevronRight} />}
        nextLinkClassName={`page-link ml-2 rounded-lg ${brandedTextClass} font-weight-bold shadow-none`}
        onPageChange={({ selected }) => props.handlePageChange(selected + 1)}
        pageClassName="page-item mx-1"
        pageCount={props.pages || 0}
        pageLinkClassName={`${brandedTextClass} page-link border-0 shadow-none`}
        pageRangeDisplayed={2}
        previousClassName="page-item"
        previousLabel={<FontAwesomeIcon icon={faChevronLeft} />}
        previousLinkClassName={`page-link mr-2 rounded-lg ${brandedTextClass} font-weight-bold shadow-none`}
      />
      {brandedBackgroundStyles}
      {brandedTextStyles}
    </>
  );
}

PaginationFooter.propTypes = {
  handlePageChange: PropTypes.func,
  page: PropTypes.number,
  pages: PropTypes.number,
  rowsLength: PropTypes.number,
  rowsLoading: PropTypes.bool,
};
